import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { USER_LIST, USER_DELETE } from 'manager/http-constants';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { PlatformComponent } from '../platform.component';
import { DeleteDialogService } from 'src/app/shared/html-parts/confirm-dialog/delete-dialog/delete-dialog.service';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-b220',
  templateUrl: './b220.component.html',
  styleUrls: ['./b220.component.scss', '../platform.component.scss'],
})

/**
 * ユーザー一覧
 */
export class B220Component extends PlatformComponent {
  //ステータス取得格納先
  statusList: object[] = new Array();

  // 検索結果一覧表示
  resultTaskDataList: object[] = new Array();

  // 件数格納先
  countTaskData: number = 0;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public DeleteDialogService: DeleteDialogService,
    public loadingState: LoadingState,
    private router: Router,
    private deleteDialogService: DeleteDialogService,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogin();
    // ユーザー結果を取得
    this.getResultTaskDataList();
  }

  /**
   * ユーザー結果を取得
   * @param loginUser.member_id 検索条件
   */
  public getResultTaskDataList(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(USER_LIST);
    // ユーザー検索結果を取得
    this.dbOperationService
      .getNoTemplateData(
        USER_LIST,
        { member_id: this.loginUser.member_id },
        false
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // ユーザー検索結果結果を格納
          this.resultTaskDataList = response.body;
        } else {
          this.resultTaskDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, USER_LIST);
      });
  }

  /**
   * ユーザ登録(B221)編集へ遷移
   * @param userId ユーザID
   */
  public moveEditB221(userId: string): void {
    // ユーザ登録(B221)編集へ遷移
    this.router.navigate(['pages/platform/b221/edit'], {
      queryParams: {
        screenId: 'b221',
        user_id: userId,
      },
    });
  }

  /**
   * ユーザ登録(B221)新規へ遷移する
   */
  public moveInsertB221(): void {
    // ユーザ登録(B221)新規へ遷移
    this.router.navigate(['pages/platform/b221/new'], {
      queryParams: {
        screenId: 'b221',
      },
    });
  }

  /**
   * 削除処理
   * @param user_id ユーザID
   */
  public deleteUser(user_id: string): void {
    // 削除ダイアログにより削除処理
    this.deleteDialogService
      .deleteDialog(USER_DELETE, 'アカウントNO', user_id, '削除')
      .subscribe(() => {
        // ユーザー結果を取得
        this.getResultTaskDataList();
      });
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });
  }
}

